import axios from "axios";
let axiosInstanceDownload = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "https://apidev.bep.ir/api",
  responseType: "blob",
  timeout: 10000,
  headers: {},
});
axiosInstanceDownload.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 500) {
      //do something
    }
    if (error.response.status === 400) {
      //do something
    }
    if (error.response.status === 401) {
      //do something
    }
    if (error.response.status === 404) {
      //do something
    }

    return Promise.reject(error);
  }
);
axiosInstanceDownload.interceptors.request.use(
  (reqConfig) => {
    if (!reqConfig.url.includes("/token-auth")) {
      reqConfig.headers["Authorization"] = `${localStorage.getItem("token")}`;
      return reqConfig;
    }
  },
  (err) => Promise.reject(err)
);
export default axiosInstanceDownload;
